export interface AuthHashSessionTokens {
	access_token: string;
	refresh_token: string | null;
	type: string | null;
}

/** Parse Supabase implicit-flow tokens from the URL hash (invite / magic link). */
export function parseAuthHashSession(hash: string): AuthHashSessionTokens | null {
	if (!hash || hash.length < 2) return null;

	const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
	const accessToken = params.get("access_token");
	if (!accessToken) return null;

	return {
		access_token: accessToken,
		refresh_token: params.get("refresh_token"),
		type: params.get("type"),
	};
}

export function hashContainsAuthSession(hash: string): boolean {
	return parseAuthHashSession(hash) !== null;
}
